import React from 'react'
import { useTranslation } from 'react-i18next'
import { TbDatabaseSearch } from 'react-icons/tb'

const NoDataFound = ({ title, titleClassName = null, iconSize = '20' }) => {
  const { t } = useTranslation()
  const titleClass = titleClassName
    ? titleClassName
    : 'text-14-dark text-center'
  return (
    <div className='w-full h-full flex-col md:flex-row gap-2 flex items-center justify-center'>
      <TbDatabaseSearch size={iconSize} className='text-iconC me-2' />
      <p className={titleClass}>{title ? title : t(`NoData`)}</p>
    </div>
  )
}

export default NoDataFound
